module.exports = __webpack_public_path__ + "img/qr-slide-mob-1.871184e3.png";